import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    if (localStorage.getItem('isLoggedin')) {
      const lastLog = localStorage.getItem('activeTime');
      if (lastLog != null && lastLog != '') {
        const date = new Date();
        const diffInMs: number = Date.parse(date.toString()) - Date.parse(lastLog);
        if (diffInMs / 1000 / 60 / 60 > 0.1) {
          this.router.navigate(['/login']).then();
          return false;
        }
      } else {
        window.location.reload();
        this.router.navigate(['/login']).then();
        return false;
      }
      const path = route.data['path'] as string;
      const level = route.data['level'] as number;
      if (level > 0) {
        if (level == 1) {
          const modules = JSON.parse(localStorage.getItem('modules') || "{}");
          const module_group = modules.find((x: any) => x.MODULE_GROUP_PATH == path);

          if (module_group != undefined) {
            if (module_group.MODULE_GROUP_ACCESS == '1') {
              const access_types = JSON.parse(localStorage.getItem('access_types') || "{}");
              let rights_array: any;
              const user_rights_array: any = {};
              rights_array = module_group.MODULE_ACCESS_RIGHTS.split('');
              for (let i = 0; i < access_types.length; i++) {
                user_rights_array[access_types[i].USER_ACCESS_TYPE_NAME] = rights_array[i];
              }
              if (user_rights_array.VIEW == '1') {
                localStorage.setItem('user_rights', JSON.stringify(user_rights_array));
              }
              localStorage.setItem('sub_modules', JSON.stringify(module_group.sub_menu));
              return true;
            } else {
              this.router.navigate(['/access-denied']).then();
              return false;
            }
          } else {
            this.router.navigate(['/access-denied']).then();
            return false;
          }
        }
        if (level == 2) {
          const sub_modules = JSON.parse(localStorage.getItem('sub_modules') || "{}");
          const access_types = JSON.parse(localStorage.getItem('access_types') || "{}");
          const module = sub_modules.find((x: any) => x.MODULE_PATH == path);
          if (module != undefined) {
            let rights_array: any;
            const user_rights_array: any = {};
            rights_array = module.MODULE_ACCESS_RIGHTS.split('');
            for (let i = 0; i < access_types.length; i++) {
              user_rights_array[access_types[i].USER_ACCESS_TYPE_NAME] = rights_array[i];
            }
            if (user_rights_array.VIEW == '1') {
              localStorage.setItem('user_rights', JSON.stringify(user_rights_array));
              return true;
            } else {
              this.router.navigate(['/access-denied']).then();
              return false;
            }
          } else {
            this.router.navigate(['/access-denied']).then();
            return false;
          }

        }
      } else {
        return true;
      }
    }

    this.router.navigate(['/login']).then();
    return false;
  }
}
